import common from './modules/common'
import category from './modules/category'
import moment from './modules/moment'
import author from './modules/author'
import help from './modules/help'
export default {
  ...common,
  ...category,
  ...moment,
  ...author,
  ...help
}
